import database from '../actions/database'
import {browserHistory, hashHistory} from "react-router";
import { watchUser } from '../actions/firebaseWatch'
import * as R from 'ramda'
import { removeCommentNotificToLocalStograge, getLocalStorage, setLocalStorage } from '../functions/snippets'
import { snapshotToArray } from '../selectors'
import History from '../functions/History'
import debounce from 'debounce'

import {
    ADD_LIST_START,
    ADD_LIST_SUCCESS,
    ADD_LIST_FAILURE,

    FETCH_LINES_START,
    FETCH_LINES_SUCCESS,
    FETCH_LINES_FAILURE,

    ADD_LINE_START,
    ADD_LINE_SUCCESS,
    ADD_LINE_FAILURE,

    EDIT_LINE_START,
    EDIT_LINE_SUCCESS,
    EDIT_LINE_FAILURE,

    ADD_IMG_TO_LINE_START,
    ADD_IMG_TO_LINE_SUCCESS,
    ADD_IMG_TO_LINE_FAILURE,

    EDIT_TITLE_START,
    EDIT_TITLE_SUCCESS,
    EDIT_TITLE_FAILURE,

    FETCH_TITLE_START,
    FETCH_TITLE_SUCCESS,
    FETCH_TITLE_FAILURE,

    ADD_TITLE_START,
    ADD_TITLE_SUCCESS,
    ADD_TITLE_FAILURE,

    ADD_TAG_START,
    ADD_TAG_SUCCESS,
    ADD_TAG_FAILURE,

    FETCH_TAGS_START,
    FETCH_TAGS_SUCCESS,
    FETCH_TAGS_FAILURE,

    FETCH_TAG_COLORS_SUCCESS,

    OPEN_COMMENTS_SUCCESS,

    FETCH_COMMENTS_SUCCESS,
    ADD_COMMENTS_SUCCSESS,
    CLOSE_COMMENTS_SUCCESS,

    FETCH_NOTIFIC_COMMENTS_IDS_SUCCESS,
    REMOVE_NOTIFIC_COMMENTS_IDS_SUCCESS,


    TOGGLE_COMMENTS_SUCCESS,

    EDIT_FAVICON_SUCCESS,

    EDIT_USER_NAME_START,
    EDIT_USER_NAME_SUCCESS,
    EDIT_USER_NAME_FAILURE,

    FETCH_USER_NAME_START,
    FETCH_USER_NAME_SUCCESS,
    FETCH_USER_NAME_FAILURE,

    FETCH_USER_START,
    FETCH_USER_SUCCESS,
    FETCH_USER_FAILURE,

    EDIT_USER_START,
    EDIT_USER_SUCCESS,
    EDIT_USER_FAILURE,

    FETCH_COMMENTS_TIME_SUCCESS,

    ADD_FILTER_TAG_IDS_SUCCESS,

    SAVE_RANGY_SUCCESS,

    FETCH_SAVED_LISTS_SUCCESS,

    FETCH_SETTINGS_SUCCESS,
    ADD_SETTINGS_SUCCESS,

    FETCH_HISTORY_START,
    FETCH_HISTORY_SUCCESS,
    FETCH_HISTORY_FAILURE,

    ADD_HISTORY_START,
    ADD_HISTORY_SUCCESS,
    ADD_HISTORY_FAILURE,

    TOGGLE_HISTORY_SUCCESS,

    ADD_KEY_LIST_SUCCESS

} from '../actionTypes';


export const addList = () => (dispatch, getState) => {
    dispatch({type: ADD_LIST_START});

    /*database.ref('/users').set({
        0: {name: "Красный", color: "red"},
        1: {name: "Синий", color: "blue"},
        2: {name: "Черный", color: "black"},
        3: {name: "Зеленый", color: "green"},
        4: {name: "Желтый", color: "yellow"},
        5: {name: "Серый", color: "gray"},
    })*/

    const listRef = database.ref('/data');
    const list = {
        title: 'Новый список',
        tagColors: [
            '#00a2ff',
            '#009688',
            '#ff0000',
            '#9e9e9e',
            '#f44336',
            '#e91e63',
            '#9c27b0',
            '#673ab7',
            '#ff5722',
            '#00bcd4',
        ],
        userCounts:1

    }
    listRef.push(list)
        .then((data) => {
            browserHistory.push("/list/" + data.key);
            list.key = data.key;
            dispatch({
                type: ADD_LIST_SUCCESS,
                payload: list
            });
            addLine(data.key)(dispatch)
           /* let oldDate = false
            let user = getState().user
            oldDate = user.historyTime ? user.historyTime.date : 2
            editUserHistoryTime(data.key, user.id, oldDate)*/


        })
        .catch((error) => {
            dispatch({type: ADD_LIST_FAILURE});
        });
}


export const fetchKeyList = (id) => dispatch => {
        dispatch({
            type: ADD_KEY_LIST_SUCCESS,
            payload: id
        })

}

export const fetchLins = key => dispatch => {
    dispatch({type: FETCH_LINES_START});
    database.ref('/data/' + key + '/lines').once('value', snap => {
        const payload = snap.val() ? snap.val() : {};
        dispatch({
            type: FETCH_LINES_SUCCESS,
            payload
        })
    })
        .catch((error) => {
            console.log(error);
            dispatch({type: FETCH_LINES_FAILURE});
        });
}

export const addLine = key => dispatch => {
    dispatch({type: ADD_LINE_START});
    const listRef = database.ref('/data/'+key+'/lines');
    const list = {
        text: '',
        checked: false,
    }
    for (let i = 0; i < 10; i++){
        listRef.push(list)

    }

        /*.then((data) => {
            //list.key = data.key;
            /!*dispatch({
                type: ADD_LINE_SUCCESS,
                payload: list
            });*!/
        })*/
       /* .catch((error) => {
            dispatch({type: ADD_LINE_FAILURE});
        });*/
}

export const fetchTitle = key => dispatch => {
    dispatch({type: FETCH_TITLE_START});
    database.ref('/data/' + key + '/title').once('value', snap => {
        const payload = snap.val() ? snap.val() : '';
        dispatch({
            type: FETCH_TITLE_SUCCESS,
            payload
        })
        let lists = localStorage.getItem('lists');
        lists = lists ? JSON.parse(lists) : {};
        const list = {
            key,
            title:payload
        }
        lists[key] = list
        localStorage.setItem('lists', JSON.stringify(lists));
    })
        .catch((error) => {
            console.log(error);
            dispatch({type: FETCH_TITLE_FAILURE});
        });
}

let fn = debounce(lineDebounce, 60000);

export const editLine = (key, keyLine, item) => (dispatch, getState) => {

    dispatch({type: EDIT_LINE_START});
    database.ref('/data/' + key + '/lines/' + keyLine).update(item, snap => {
        /*const payload = snap.val() ? snap.val() : {};
        dispatch({
            type: EDIT_LINE_SUCCESS,
            payload
        })*/
        const history = new History(dispatch, getState)
        fn(history, key, keyLine)

    })
        .catch((error) => {
            console.log(error);
            dispatch({type: EDIT_LINE_FAILURE});
        });
}




function lineDebounce(history, key, keyLine){
    addHistory(history.watchLine(key, keyLine))

}

export const editChecked = (key, keyLine, item) => async(dispatch, getState) => {
    dispatch({type: EDIT_LINE_START});
    database.ref('/data/' + key + '/lines/' + keyLine).update(item, snap => {
        /*const payload = snap.val() ? snap.val() : {};
        dispatch({
            type: EDIT_LINE_SUCCESS,
            payload
        })*/
    })
        .catch((error) => {
            console.log(error);
            dispatch({type: EDIT_LINE_FAILURE});
        });

    const history = new History(dispatch, getState)
    addHistory(history.watchChecked(key, keyLine))
}


export const updateDateLine = (key, keyLine, user)  => {
    database.ref('/data/' + key + '/lines/' + keyLine + '/date').set(Date.now(), snap => {
        database.ref('/data/' + key + '/lines/' + keyLine + '/userUpdate').set(user.id, snap => {})
    })
}

export const addImgToLine = (key, keyLine, file) => dispatch => {
    dispatch({type: ADD_IMG_TO_LINE_START});
    database.ref('/data/' + key + '/lines/' + keyLine + '/img').push(file, snap => {
        dispatch({type: ADD_IMG_TO_LINE_SUCCESS,})

    })
        .catch((error) => {
            console.log(error);
            dispatch({type: EDIT_LINE_FAILURE});
        });
}

export const removeLine = (key, keyLine) => dispatch => {
    database.ref('/data/' + key + '/lines/' + keyLine).remove();
}

export const toggleDropBox = type => (dispatch, getState) => {
    if(type == TOGGLE_COMMENTS_SUCCESS && getState().dropBox.comments){
        dispatch({ type: CLOSE_COMMENTS_SUCCESS, payload: {} });
        dispatch({ type: FETCH_COMMENTS_SUCCESS, payload: {} });


    }
    dispatch({ type: type });
}

export const editTitle = (key, title) => async (dispatch, getState) => {
    dispatch({type: EDIT_TITLE_START});
    title = title ? title : ' '

    database.ref('/data/' + key + '/title').set(title, snap => {
        /*const payload = snap.val() ? snap.val() : {};
         dispatch({
         type: EDIT_TITLE_SUCCESS,
         payload
         })*/
    })
        .catch((error) => {
            console.log(error);
            dispatch({type: EDIT_TITLE_FAILURE});
        });

    const user = getState().user
    const listRef =  database.ref('/authUsers/' + user.id + '/lists/' + key + '/title');
    const con = await listRef.once("value")

    if(con.val()){
        listRef.set(title)
    }


}

export const fetchTags = key => dispatch => {
    dispatch({type: FETCH_TAGS_START});
    database.ref('/data/' + key + '/tags').once('value', snap => {
        const payload = snap.val() ? snap.val() : {};
        dispatch({
            type: FETCH_TAGS_SUCCESS,
            payload
        })
    })
        .catch((error) => {
            console.log(error);
            dispatch({type: FETCH_TAGS_FAILURE});
        });
}

export const addTag = (key, text) => (dispatch, getState) => {
    if(!text) return
    dispatch({type: ADD_TAG_START});
    const listRef = database.ref('/data/'+key+'/tags');
    const colors = getState().tagColors;
    let randomColor = randomInteger(0, colors.length - 1)
    const list = {
        text: text,
        color: colors.length ? colors[randomColor] : '#000000'
    }
    colors.length && colors.splice(randomColor, 1);

    function randomInteger(min, max) {
        var rand = min - 0.5 + Math.random() * (max - min + 1)
        rand = Math.round(rand);
        return rand;
    }
    listRef.push(list)
        .then((data) => {
            database.ref('/data/' + key + '/tagColors').set(colors, snap => {
                console.log
            })
                .catch((error) => {
                    console.log(error);
                    dispatch({type: EDIT_TITLE_FAILURE});
                });
        })
        .catch((error) => {
            dispatch({type: ADD_TAG_FAILURE});
        });
}

export const removeTag = (key, keyLine) => dispatch => {
    database.ref('/data/' + key + '/tags/' + keyLine).remove();
}


export const fetchTagsColor = key => dispatch => {
    database.ref('/data/' + key + '/tagColors').once('value', snap => {
        const payload = snap.val() ? snap.val() : {};
        dispatch({
            type: FETCH_TAG_COLORS_SUCCESS,
            payload
        })
    })
        .catch((error) => {
            console.log(error);
        });
}

export const addTagToLine = (id, keyTag, keyLine) => async(dispatch, getState) => {
    const listRef = database.ref('/data/'+id+'/lines/'+keyLine+'/tags');
    let line = getState().lines[keyLine]
    let tags = getState().lines[keyLine].tags
    tags = tags ? tags : [];

    const index = tags.indexOf( keyTag ) != -1;
    index ?
        tags.splice(tags.indexOf(keyTag), 1):
        tags.push(keyTag);

    await listRef.set(tags, snap => {})



    const history = new History(dispatch, getState)
    addHistory(history.watchTag(id, keyTag, keyLine))
}


export const openComments = (line, keyList) => (dispatch, getState) => {
    const user = getState().user;


    dispatch({
        type: OPEN_COMMENTS_SUCCESS,
        payload: line
    })

    let oldDate = false
    if(user.commentsTime){
        oldDate = user.commentsTime[line.id] ? user.commentsTime[line.id].date : 2
    }

    editUserCommentTime(keyList, user.id, line.id, oldDate)
}

export const toggleHistory = () => (dispatch, getState) => {
    const user = getState().user;
    const keyList = getState().keyList;
    const isOpen = getState().dropBox.history;

    if(!isOpen){
        let oldDate = false
        oldDate = user.historyTime ? user.historyTime.date : 2
        editUserHistoryTime(keyList, user.id, oldDate)
    }

    dispatch({
        type: TOGGLE_HISTORY_SUCCESS,
        payload: {}
    })

}

export const editUserCommentTime = (keyList, userId, lineId, oldDate) => {
    const userCommentTimeRef = database.ref('/data/'+keyList+'/users/' + userId + '/commentsTime/' + lineId);
    const date = {
        date: Date.now(),
        keyLine: lineId,
    }

    if(oldDate){
        date.oldDate = oldDate
    }
    userCommentTimeRef.set(date)

}

export const editUserHistoryTime = (keyList, userId, oldDate) => {
    const userCommentTimeRef = database.ref('/data/'+keyList+'/users/' + userId + '/historyTime/');
    const date = {
        date: Date.now(),
    }

    if(oldDate){
        date.oldDate = oldDate
    }
    userCommentTimeRef.set(date)

}

export const editUserLineUpdateTime = (keyList, userId, lineId) => dispatch => {
    const userLineUpdateTimeRef = database.ref('/data/'+keyList+'/users/' + userId + '/lineUpdateTime/' + lineId);
    const date = {
        date: Date.now(),
        keyLine: lineId,
    }
    userLineUpdateTimeRef.set(date)
}






export const fetchComments = (key, keyLine, user) => dispatch => {

    database.ref('/data/' + key + '/comments').orderByChild("keyLine").equalTo(keyLine).once('value', snap => {
        const payload = snap.val() ? snap.val() : {};
        dispatch({
            type: FETCH_COMMENTS_SUCCESS,
            payload
        })


    })
        .catch((error) => {
            console.log(error);
        });
}

export const addComment = (id, comment) => (dispatch, getState) => {
    const listRef = database.ref('/data/'+id+'/comments');
    const commentsTime = database.ref('/data/'+id+'/commentsTime/' + comment.keyLine);

    const time = {
        date: comment.date,
        keyLine: comment.keyLine
    }
    commentsTime.set(time)
    listRef.push(comment)
        .then((data) => {
            /*console.log(data.key)
            console.log(comment)
            const commentTemp = {}
            commentTemp[data.key] = comment;
            dispatch({
                type: ADD_COMMENTS_SUCCSESS,
                payload: commentTemp
            });*/

            const history = new History(dispatch, getState)
            addHistory(history.watchComment(id, comment.keyLine, comment))

        })
        .catch((error) => {
            //dispatch({type: ADD_LINE_FAILURE});
        });
}

export const fetchNotificCommentIds = () => dispatch => {
    const commentsNotificIds = JSON.parse(localStorage.getItem('notificCommentIds'))

    dispatch({
        type: FETCH_NOTIFIC_COMMENTS_IDS_SUCCESS,
        payload: commentsNotificIds ? commentsNotificIds : []
    })
}

export const removeNotificCommentIds = () => dispatch => {
    const commentsNotificIds = JSON.parse(localStorage.getItem('notificCommentIds'))

    dispatch({
        type: REMOVE_NOTIFIC_COMMENTS_IDS_SUCCESS,
        payload: commentsNotificIds
    })
}

export const editFavicon = fav => dispatch => {
    dispatch({
        type: EDIT_FAVICON_SUCCESS,
        payload: fav
    })
}

export const fetchUserName = (key) => dispatch => {
    dispatch({type: FETCH_USER_NAME_START});
    const userName = JSON.parse(localStorage.getItem('userName'))
    if(userName) {
        dispatch({
            type: FETCH_USER_NAME_SUCCESS,
            payload: userName
        })
    }else{
        database.ref('/data/' + key + '/userCounts').once('value', snap => {
            let userCounts = snap.val() ? snap.val() : 1;
            database.ref('/users/' + userCounts).once('value', snap => {
                const userName = snap.val() ? snap.val() : {name: 'че то че то', color: 'black'};

                localStorage.setItem('userName', JSON.stringify(userName))
                dispatch({
                    type: FETCH_USER_NAME_SUCCESS,
                    payload: userName
                })

                database.ref('/data/' + key + '/userCounts').set(++userCounts)
                let userId = database.ref().push().key;
                userName.id = userId;

                database.ref('/data/' + key + '/users/' + userId).set(userName)
            })
        })

    }
}


export const editUserName = (name) => dispatch => {
    const userName = JSON.parse(localStorage.getItem('userName'))
    userName.name = name;
    dispatch({
        type: EDIT_USER_NAME_SUCCESS,
        payload: userName
    })
    localStorage.setItem('userName', JSON.stringify(userName))
}


export const fetchUser =  (key) => async dispatch => {
    let newUser = false;
        //database.ref('/data/-LCxoHmJrMQP6JlOfbpJ//users').remove()
        dispatch({type: FETCH_USER_START});
        const users = JSON.parse(localStorage.getItem('users')) ? JSON.parse(localStorage.getItem('users')) : {}
        let userActive = users[key]
        if(userActive) {
            dispatch({
                type: FETCH_USER_SUCCESS,
                payload: userActive
            })
            watchUser(key, userActive.id)(dispatch)
        }else{
            let snap =  await database.ref('/data/' + key + '/users').once("value")
            let usersLength = snap.numChildren();

            snap =   await database.ref('/users/' + usersLength).once('value')
            const user = snap.val() ? snap.val() : {name: 'user'+usersLength, color: 'black'};
            let userId = await database.ref().push().key;
            user.id = userId;
            users[key] = user

            dispatch({
                type: FETCH_USER_SUCCESS,
                payload: user
            })

            snap = await database.ref('/data/' + key + '/users/' + userId).set(user);
            await watchUser(key, userId)(dispatch)

            newUser = true



            /*await database.ref('/data/' + key + '/users').once("value", async(snap) => {
                console.log(4)
                let usersLength = snap.numChildren();
                console.log(usersLength)
                await database.ref('/users/' + usersLength).once('value', async snap => {
                    const user = snap.val() ? snap.val() : {name: 'user'+usersLength, color: 'black'};
                    let userId = database.ref().push().key;
                    user.id = userId;
                    users[key] = user

                    dispatch({
                        type: FETCH_USER_SUCCESS,
                        payload: user
                    })



                    await database.ref('/data/' + key + '/users/' + userId).set(user,  async() => {
                       await watchUser(key, userId)(dispatch)

                        newUser = true
                    })

                    console.log(1111111111)
                })

            })*/

        }


    return newUser

}

export const newUser = (key, user) => dispatch => {
    dispatch({
        type: FETCH_USER_SUCCESS,
        payload: user
    })

    database.ref('/data/' + key + '/users/' + user.id).set(user, () => {
        watchUser(key, user.id)(dispatch)
    })
}


export const editUser = (key, user) => dispatch => {
    dispatch({type: EDIT_USER_START});


    /*database.ref('/data/' + key + '/users/' + user.id).once('value', (snap) => {
        console.log(snap.val())
    })*/



    database.ref('/data/' + key + '/users/' + user.id ).set(user, snap => {
        dispatch({
            type: FETCH_USER_SUCCESS,
            payload: user
        })
        watchUser(key, user.id)(dispatch)
    })
        .catch((error) => {
            console.log(error);
            dispatch({type: EDIT_USER_FAILURE});
        });
}

export const fetchCommentsTime = key => dispatch => {
    database.ref('/data/' + key + '/commentsTime/').once('value', snap => {
        const payload = snap.val()
        dispatch({
            type: FETCH_COMMENTS_TIME_SUCCESS,
            payload: payload
        })
    })
        .catch((error) => {
            console.log(error);
            dispatch({type: EDIT_USER_FAILURE});
        });
}

export const addFilterTagIds = id => (dispatch, getState) => {
    //const commentsNotificIds = JSON.parse(localStorage.getItem('notificCommentIds'))
    let ids = getState().filterTagIds
    if(R.indexOf(id, ids) + 1){
        let index = R.indexOf(id, ids);
        ids = R.remove(index, 1, ids)
    }else{
        ids.push(id)
    }
    dispatch({
        type: ADD_FILTER_TAG_IDS_SUCCESS,
        payload: ids
    })
}

export const saveRangy = rangy => dispatch => {
    dispatch({
        type: SAVE_RANGY_SUCCESS,
        payload: rangy
    })
}

export const saveAuthUser = async (data) => {
    const user = {}
    user.name = data.name;
    user.id = data.id;
    let snap = await database.ref('/authUsers/' + data.id).once("value");
    if(!snap.val()){
        database.ref('/authUsers/' + data.id).set(user, () => {})
    }
}

export const saveAuthUseList = async (idUser, idList, title) => {
    const listRef =  database.ref('/authUsers/' + idUser + '/lists/' + idList);
    const list = {
        id: idList,
        title
    };
    await listRef.set(list)

    return list
}

export const removeAuthUseList = async (idUser, idList) => {
    const listRef =  database.ref('/authUsers/' + idUser + '/lists/' + idList);
    await listRef.remove()

    return idList
}

export const isSavedList = async (idUser, idList) => {

    const listRef =  database.ref('/authUsers/' + idUser + '/lists/' + idList);

    const con = await listRef.once("value")


    return con.val() ? true : false
}

export const fetchAuthUseList = idUser => async (dispatch, getState) => {
    const listRef =  database.ref('/authUsers/' + idUser + '/lists/');
    let snap = await listRef.once("value");

    dispatch({
        type: FETCH_SAVED_LISTS_SUCCESS,
        payload: snap.val()
    })

    return snap
}

export const fetchSettings = key => dispatch => {
    const payload = getLocalStorage('settings', key)
    dispatch({
        type: FETCH_SETTINGS_SUCCESS,
        payload
    })
}

export const addSettings = (key, data) => dispatch => {
    if(data.label !== 'searchLine'){
        setLocalStorage(key, 'settings', data)
    }
    dispatch({
        type: ADD_SETTINGS_SUCCESS,
        payload: data
    })
}

export const setDateOnLine =  (key, keyLine, data, tempDate) => async (dispatch, getState) => {
    const listRef =  database.ref('/data/' + key + '/lines/' + keyLine + '/dates');
    let snap = await listRef.set(data);
    const user = getState().user
    updateDateLine(key, keyLine, user)

    const history = new History(dispatch, getState)
    addHistory(history.watchDate(key, keyLine, tempDate))
}

export const fetchHistory = (key) => async dispatch => {
    const listRef =  database.ref('/data/' + key + '/history');
    const payload = await listRef.once('value')

    console.log(payload.val())

    dispatch({
        type: FETCH_HISTORY_SUCCESS,
        payload: payload.val(),
    })
}

export const addHistory = (res) => {
    const { id, data, dispatch} = res
    const listRef =  database.ref('/data/' + id + '/history');

    //console.log(res)
    listRef.push(data)

    /*dispatch({
        type: ADD_HISTORY_SUCCESS,
        payload: data
    })*/
}



// WEBPACK FOOTER //
// ./src/actions/index.js